import { render, staticRenderFns } from "./AfiliacionSistemaRiesgosPagination.vue?vue&type=template&id=3e7fff14&"
import script from "./AfiliacionSistemaRiesgosPagination.vue?vue&type=script&lang=js&"
export * from "./AfiliacionSistemaRiesgosPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports